import React, { useCallback } from "react";
import { Tag } from "antd";
import moment from "moment";
import {
  ShipmentStatusMap,
  InvoiceStatusMap,
  BillStatusMap,
  VehicleTypeMap,
  SecurePassAutoSendMap,
  SECURE_PASS_TAG_STATUS_MAP,
  SecurePassLogTypeMap,
} from "@/utils/enum";
import { cleanObjectFromUndefined } from "@/utils/utils";
import { DATE_KEYS } from "@/components/SortAndFilter/DateRangeFilter";
import { filterName, filterValueText, flagStatusNames, renamedColumns } from "./constants";

const FilterTags = ({
  filters,
  stateNames,
  dealersName,
  entityGroupNames,
  transportersName,
  managersName,
  onRemove,
}) => {
  const onClose = useCallback(
    (filterKey, value) => {
      if (typeof onRemove === "function") {
        onRemove(filterKey, value);
      }
    },
    [onRemove],
  );

  return Object.keys(cleanObjectFromUndefined(filters)).map(filterKey => {
    let values = [];
    const name = renamedColumns[filterKey] || filterName[filterKey];
    let value = filters[filterKey];
    const originalValue = value;
    value = filterValueText[value] || value;

    if (name === undefined) {
      return null;
    }

    if (["stateId", "pickupStateId", "dropOffStateId"].includes(filterKey)) {
      value = stateNames[value];
    } else if (filterKey === "stateIds") {
      values = value.map(stateId => ({
        value: stateNames[stateId],
        originalValue: stateId,
      }));
    } else if (["city", "pickupCity", "dropOffCity"].includes(filterKey)) {
      // keeps the same value
    } else if (filterKey === "cities") {
      values = value.map(city => ({
        value: city,
        originalValue: city,
      }));
    } else if (filterKey === "flagStatus") {
      value = flagStatusNames[value];
    } else if (filterKey === "dealerId") {
      value = dealersName[value];
    } else if (filterKey === "rating") {
      if (value === -1) {
        value = `Not Rated`;
      } else {
        value = `${value} Stars`;
      }
    } else if (filterKey === "companyGroupId") {
      value = entityGroupNames[value];
    } else if (Object.values(DATE_KEYS).includes(filterKey)) {
      const [start, end] = value ? value.split("/") : [];

      if (start && end) {
        value = `${moment(start).format("DD/MM/YYYY")} - ${moment(end).format("DD/MM/YYYY")}`;
      }
    } else if (filterKey === "shipmentStatus") {
      value = ShipmentStatusMap[value];
    } else if (filterKey === "billStatus") {
      value = BillStatusMap[value];
    } else if (filterKey === "invoiceStatus") {
      value = InvoiceStatusMap[value];
    } else if (filterKey === "transporterId") {
      value = transportersName[value];
    } else if (filterKey === "vehicleType") {
      value = VehicleTypeMap[value];
    } else if (filterKey === "managerId") {
      value = managersName[value];
    } else if (filterKey === "securePassAutoSendType") {
      value = SecurePassAutoSendMap[value];
    } else if (filterKey === "securePassValue") {
      value = SECURE_PASS_TAG_STATUS_MAP[value];
    } else if (filterKey === "securePassLogType") {
      value = SecurePassLogTypeMap[value];
    }

    if (values.length === 0) {
      values = [{ value, originalValue }];
    }

    return values.map(({ value, originalValue }) => (
      <Tag
        closable
        key={filterKey + originalValue}
        style={{ borderColor: "silver", maxHeight: 25, marginBottom: 10 }}
        onClose={() => onClose(filterKey, originalValue)}
      >
        <span>
          <span style={{ fontWeight: "bold", color: "black" }}>{`${name}:`} </span>

          <span>{value}</span>
        </span>
      </Tag>
    ));
  });
};

export default FilterTags;
